import script from "./GstHero.vue?vue&type=script&setup=true&lang=js"
export * from "./GstHero.vue?vue&type=script&setup=true&lang=js"

import "./GstHero.vue?vue&type=style&index=0&id=2d33b126&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d33b126"]])

export default __exports__